import { PaletteMode } from "@mui/material";
import { isLumio } from "utils/platformStyle";

const LUMIO_PRIMARY = {
  light: "#3399ff",
  main: "#007bff",
  dark: "#0069d9",
  contrastText: "#fff",
};

const defaultPrimaryLight = {
  light: "#94bec2",
  main: "#277e87",
  contrastText: "#fff",
};

const defaultPrimaryDark = {
  main: "#00a4a9",
  light: "#2196f3",
  dark: "#006b69",
  contrastText: "#fff",
};

export const light = {
  alternate: {
    main: "#f7faff",
    dark: "rgb(4, 3, 37)",
  },
  cardShadow: "rgba(23, 70, 161, .11)",
  mode: "light" as PaletteMode,
  primary: isLumio() ? LUMIO_PRIMARY : defaultPrimaryLight,
  secondary: {
    light: "#ffb74d",
    //#f9b934 secondary color
    main: "#ba9542",
    dark: "#FF9800",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  text: {
    primary: "#1e2022",
    secondary: "rgb(108, 109, 132)",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  background: {
    paper: "#ffffff",
  
    default: "#ffffff",
    level2: "#f5f5f5",
    level1: "#ffffff",
  },
  online_status: {
    online: "#3DBE02",
    offline: "#FF8914"
  },
  sync_status: {
    syncing: "#269FFF",
    pending: "#FF8914",
    success: "#3DBE02",
    failed: "#FF2626"
  },
};

export const dark = {
  alternate: {
    // main #1a2138
    main: "#000",
    dark: "#151a30",
  },
  cardShadow: "rgba(0, 0, 0, .11)",
  common: {
    black: "#000",
    white: "#fff",
  },
  mode: "dark" as PaletteMode,
  primary: isLumio() ? LUMIO_PRIMARY : defaultPrimaryDark,
  secondary: {
    light: "#FFEA41",
    main: "#FFE102",
    dark: "#DBBE01",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  text: {
    primary: "#EEEEEF",
    secondary: "#AEB0B4",
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    //paper #222B45
    paper: "#000",
    //default #222B45
    default: "#000",
    level2: "#333",
    level1: "#2D3748",
  },
  online_status: {
    online: "#3DBE02",
    offline: "#FF8914"
  },
  sync_status: {
    syncing: "#269FFF",
    pending: "#FF8914",
    success: "#3DBE02",
    failed: "#FF2626",
  },
};
